export const adHeadersData = [
  {
    text: 'ID',
    value: 'id',
    sortable: false,
  },
  {
    text: 'Image',
    value: 'image',
    sortable: false,
  },
  {
    text: 'Title',
    value: 'title',
    sortable: true,
  },
  {
    text: 'Client',
    value: 'client',
    sortable: true,
  },
  {
    text: 'Link',
    value: 'link',
    sortable: false,
  },
  {
    text: 'Impressions',
    value: 'impressions',
    sortable: true,
  },
  {
    text: 'Clicks',
    value: 'clicks',
    sortable: true,
  },
  {
    text: 'CTR',
    value: 'ctr',
    sortable: true,
  },
  {
    text: '',
    value: '',
    sortable: false,
  }
];

export const adCampaignHeadersData = [
  {
    text: 'Title',
    value: 'title',
    sortable: false,
  },
  {
    text: 'Description',
    value: 'description',
    sortable: false,
  },
  {
    text: 'Campaign Region',
    value: 'region',
    sortable: false,
  },
  {
    text: 'Status',
    value: 'status',
    sortable: false,
  },
  {
    text: 'Client',
    value: 'client',
    sortable: false,
  },
  {
    text: '',
    value: 'actions',
    sortable: false,
  },
];

export const adClientHeadersData = [
  {
    text: 'Id',
    value: 'id',
    sortable: false,
  },
  {
    text: 'Name',
    value: 'name',
    sortable: false,
  },
  {
    text: '',
    value: 'actions',
    sortable: false,
  },
];
